<template>
  <el-container class="fm2-container">
    <el-main class="fm2-main">
      <el-container>
        <el-aside width="260px">
          <div class="components-list">
            <div class="widget-cate">基础组件</div>
            <draggable
              tag="ul"
              :list="basicComponents"
              v-bind="{
                group: { name: 'people', pull: 'clone', put: false },
                sort: false,
                ghostClass: 'ghost',
              }"
              @end="handleMoveEnd"
              @start="handleMoveStart"
              :move="handleMove"
            >
              <li
                class="form-edit-widget-label"
                v-for="(item, index) in basicComponents"
                :class="{
                  'widget-in-comment':
                    item.type === 'input' ||
                    item.type === 'textarea' ||
                    item.type === 'esign' ||
                    item.type === 'date' ||
                    item.type === 'time',
                }"
                :key="index"
              >
                <a>
                  <i
                    v-if="item.icon.indexOf('sw-icon') === 0"
                    class="icon"
                    :class="item.icon"
                  ></i>
                  <i v-else class="icon iconfont" :class="item.icon"></i>
                  <span>{{ item.name }}</span>
                </a>
              </li>
            </draggable>

            <div class="widget-cate">高级组件</div>
            <draggable
              tag="ul"
              :list="advanceComponents"
              v-bind="{
                group: { name: 'people', pull: 'clone', put: false },
                sort: false,
                ghostClass: 'ghost',
              }"
              @end="handleMoveEnd"
              @start="handleMoveStart"
              :move="handleMove"
            >
              <li
                class="form-edit-widget-label"
                v-for="(item, index) in advanceComponents"
                :key="index"
                :class="{ 'widget-un-son': item.type === 'sonform' }"
              >
                <a>
                  <i
                    v-if="item.icon.indexOf('sw-icon') === 0"
                    class="icon"
                    :class="item.icon"
                  ></i>
                  <i
                    v-else-if="item.icon.indexOf('su') === 0"
                    class="icon"
                    :class="item.icon"
                  ></i>
                  <i v-else class="icon iconfont" :class="item.icon"></i>
                  <span>{{ item.name }}</span>
                </a>
              </li>
            </draggable>

            <div class="widget-cate">布局组件</div>
            <draggable
              tag="ul"
              :list="layoutComponents"
              v-bind="{
                group: { name: 'people', pull: 'clone', put: false },
                sort: false,
                ghostClass: 'ghost',
              }"
              @end="handleMoveEnd"
              @start="handleMoveStart"
              :move="handleMove"
            >
              <li
                class="form-edit-widget-label data-grid"
                v-for="(item, index) in layoutComponents"
                :key="index"
                :class="{
                  'widget-un-son':
                    item.type === 'grid' ||
                    item.type === 'comment' ||
                    item.type === 'page',
                  'widget-in-comment': item.type === 'grid',
                }"
              >
                <a>
                  <i
                    v-if="item.icon.indexOf('sw-icon') === 0"
                    class="icon"
                    :class="item.icon"
                  ></i>
                  <i v-else class="icon iconfont" :class="item.icon"></i>
                  <span>{{ item.name }}</span>
                </a>
              </li>
            </draggable>

            <div class="widget-cate">业务组件</div>
            <draggable
              tag="ul"
              :list="businessComponents"
              v-bind="{
                group: { name: 'people', pull: 'clone', put: false },
                sort: false,
                ghostClass: 'ghost',
              }"
              @end="handleMoveEnd"
              @start="handleMoveStart"
              :move="handleMove"
            >
              <li
                class="form-edit-widget-label data-grid"
                v-for="(item, index) in businessComponents"
                :key="index"
              >
                <a>
                  <i
                    v-if="item.icon.indexOf('sw-icon') === 0"
                    class="icon"
                    :class="item.icon"
                  ></i>
                  <i v-else class="icon iconfont" :class="item.icon"></i>
                  <span>{{ item.name }}</span>
                </a>
              </li>
            </draggable>

            <!-- <div class="widget-cate">查询组件</div>
            <draggable
              tag="ul"
              :list="searchComponents"
              v-bind="{group:{ name:'people', pull:'clone',put:false},sort:false, ghostClass: 'ghost'}"
              @end="handleMoveEnd"
              @start="handleMoveStart"
              :move="handleMove"
            >
              <li
                class="form-edit-widget-label data-grid"
                v-for="(item, index) in searchComponents"
                :key="index"
              >
                <a>
                  <i
                    v-if="item.icon.indexOf('sw-icon') === 0"
                    class="icon"
                    :class="item.icon"
                  ></i>
                  <i
                    v-else
                    class="icon iconfont"
                    :class="item.icon"
                  ></i>
                  <span>{{item.name}}</span>
                </a>
              </li>
            </draggable> -->
          </div>
        </el-aside>
        <el-container class="center-container" direction="vertical">
          <el-header class="btn-bar" style="height: 45px">
            <slot name="action"></slot>
            <el-tabs v-model="pageTab" type="card" class="sw-tab-page">
              <el-tab-pane label="主页面" name="main"></el-tab-pane>
              <el-tab-pane
                v-for="(tab, key) in widgetForm.sonPages"
                :key="key"
                :label="tab.title ? tab.title : tab.key"
                :name="key"
              ></el-tab-pane>
            </el-tabs>
            <el-button
              v-if="buttonConfig.fullScreen"
              type="text"
              size="medium"
              icon="el-icon-full-screen"
              @click="handleFullScreen"
            >
              全屏</el-button
            >
            <el-button
              v-if="buttonConfig.selectModel"
              type="text"
              size="medium"
              icon="el-icon-add"
              @click="handleChangeModel"
              >选择模型
            </el-button>
            <el-button
              v-if="preview"
              type="text"
              size="medium"
              icon="el-icon-view"
              @click="handlePreview"
              >预览
            </el-button>
            <el-button
              v-if="preview"
              type="text"
              size="medium"
              icon="el-icon-mobile"
              @click="handleMobilePreview"
              >移动端
            </el-button>
            <el-button
              v-if="buttonConfig.save"
              type="text"
              size="medium"
              icon="el-icon-check"
              :class="{ canClick: canNotSave }"
              :disabled="canNotSave"
              @click="saveFormConfirm"
              >保存并关闭</el-button
            >

            <!--<el-button v-if="generateCode" type="text" size="medium" icon="el-icon-document" @click="handleGenerateCode">生成代码</el-button>-->

            <el-dropdown style="margin-left: 10px" trigger="click">
              <span class="el-dropdown-link">
                <el-button type="text" size="medium" icon="el-icon-arrow-down"
                  >更多</el-button
                >
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button
                    v-if="buttonConfig.save"
                    type="text"
                    size="medium"
                    icon="el-icon-check"
                    :class="{ canClick: canNotSave }"
                    :disabled="canNotSave"
                    @click="saveFormConfirmNoClose"
                    >保存</el-button
                  >
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    v-if="generateJson"
                    type="text"
                    size="medium"
                    icon="el-icon-tickets"
                    @click="handleGenerateJson"
                    >生成JSON</el-button
                  >
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    v-if="upload"
                    type="text"
                    size="medium"
                    icon="el-icon-upload2"
                    @click="handleUpload"
                    >导入JSON
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    v-if="tplChoice"
                    type="text"
                    size="medium"
                    icon="el-icon-document-add"
                    @click="handleTpl"
                  >
                    导入模板</el-button
                  >
                </el-dropdown-item>

                <el-dropdown-item divided>
                  <el-button
                    v-if="clear"
                    type="text"
                    size="medium"
                    icon="el-icon-delete"
                    style="color: red"
                    @click="handleClear"
                    >清空</el-button
                  >
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-header>
          <el-main :class="{ 'widget-empty': widgetForm.list.length === 0 }">
            <widget-form
              v-if="!resetJson && pageTab === 'main'"
              ref="widgetForm"
              :data="widgetForm"
              :select.sync="widgetFormSelected"
            ></widget-form>
            <widget-son-page-form
              v-if="!resetJson && pageTab !== 'main'"
              ref="widgetSonPageForm"
              :config="widgetForm.config"
              :page-tab="pageTab"
              :son-pages="widgetForm.sonPages"
              :page.sync="curPage"
              :select.sync="widgetFormSelected"
            ></widget-son-page-form>
          </el-main>
        </el-container>
        <el-aside class="widget-config-container" style="width: 320px">
          <el-container>
            <el-header height="45px">
              <div
                class="config-tab"
                :class="{ active: configTab === 'widget' }"
                @click="handleConfigSelect('widget')"
              >
                字段属性
              </div>
              <div
                class="config-tab"
                :class="{ active: configTab === 'event' }"
                @click="handleConfigSelect('event')"
              >
                函数事件
              </div>
              <div
                class="config-tab"
                :class="{ active: configTab === 'form' }"
                @click="handleConfigSelect('form')"
              >
                表单设置
              </div>
            </el-header>
            <el-main class="config-content">
              <template v-if="widgetFormSelected && widgetFormSelected.key">
                <widget-config
                  v-show="configTab === 'widget'"
                  :design-id="formInfo.id"
                  :data="widgetFormSelected"
                  :table-list="tableList"
                  :form-info="formInfo"
                  :son-pages="widgetForm.sonPages"
                  :widget-form="widgetForm"
                ></widget-config>
                <sw-event-config
                  v-show="configTab === 'event'"
                  :design-id="formInfo.id"
                  :data="widgetFormSelected"
                  :widget-form="widgetForm"
                  :page-tab="pageTab"
                ></sw-event-config>
              </template>
              <form-config
                v-show="configTab === 'form'"
                :data="widgetForm.config"
                :son-pages="widgetForm.sonPages"
                :list="widgetForm.list"
                :page-tab.sync="pageTab"
                :model-json="modelJson"
                @success="handleSuccess"
              ></form-config>
            </el-main>
          </el-container>
        </el-aside>

        <cus-dialog
          :visible="previewVisible"
          :title="'预览表单'"
          @on-close="previewVisible = false"
          ref="widgetPreview"
          @on-submit="handlePcTest"
          width="80%"
          form
        >
          <generate-form
            insite="true"
            v-if="previewVisible"
            :widget-form="widgetForm"
            :value="widgetModels"
            :remote="remoteFuncs"
            :disabled="false"
            :currentUser="currentUser"
            ref="generateForm"
          ></generate-form>
        </cus-dialog>
        <mobile-dialog
          :visible="previewMobileVisible"
          @on-close="previewMobileVisible = false"
          ref="widgetMobilePreview"
          @on-submit="handleMobileTest"
          width="375px"
          :mobileData="{ widgetForm, widgetModels, currentUser, remoteFuncs }"
        >
          <iframe
            id="mobileIframe"
            width="375px"
            style="height: calc(80vh - 46px); max-height: 712px"
            frameborder="0"
            :src="mobileUrl"
          />
        </mobile-dialog>
        <cus-dialog
          :visible="tplVisible"
          @on-close="tplVisible = false"
          @on-submit="handleTplJson"
          ref="tplChoice"
          form
        >
          <el-select
            :loading="!tplFormList.length"
            v-model="formTplSelected"
            placeholder="请选择表单模板"
            @change="formTplSelectedChange"
          >
            <el-option
              v-for="item in tplFormList"
              :key="item.id"
              :label="item.form_name"
              :value="item.id"
            ></el-option>
          </el-select>
          <textarea
            v-model="ftsjResolve"
            style="
              width: calc(100% - 20px);
              min-height: 400px;
              margin-top: 20px;
            "
            disabled
          />
        </cus-dialog>
        <cus-dialog
          :visible="uploadVisible"
          @on-close="uploadVisible = false"
          @on-submit="handleUploadJson"
          ref="uploadJson"
          width="800px"
          form
        >
          <el-alert
            type="info"
            title="JSON格式如下，直接复制生成的json覆盖此处代码点击确定即可"
          ></el-alert>
          <div id="uploadeditor" style="height: 400px; width: 100%">
            {{ jsonEg }}
          </div>
        </cus-dialog>

        <cus-dialog
          :visible="jsonVisible"
          @on-close="jsonVisible = false"
          ref="jsonPreview"
          width="800px"
          form
        >
          <div id="jsoneditor" style="height: 400px; width: 100%">
            {{ jsonTemplate }}
          </div>
          <template slot="action">
            <el-button id="copybtn" data-clipboard-target=".ace_text-input"
              >双击复制</el-button
            >
          </template>
        </cus-dialog>

        <cus-dialog
          :visible="codeVisible"
          @on-close="codeVisible = false"
          ref="codePreview"
          width="800px"
          form
          :action="false"
        >
          <div id="codeeditor" style="height: 500px; width: 100%">
            {{ htmlTemplate }}
          </div>
        </cus-dialog>
      </el-container>
    </el-main>
  </el-container>
</template>
<script src="componentsConfig.js"></script>
<script>
import Draggable from 'vuedraggable'
import screenfull from 'screenfull'
import WidgetConfig from './WidgetConfig'
import FormConfig from './FormConfig'
import SwEventConfig from './SwEventConfig'
import WidgetForm from './WidgetForm'
import CusDialog from './CusDialog'
import MobileDialog from './MobileDialog.vue'
import GenerateForm from './GenerateForm'

import Clipboard from 'clipboard'
import {
  basicComponents,
  layoutComponents,
  advanceComponents,
  businessComponents,
  searchComponents,
} from './componentsConfig.js'
import { jsonEgStr } from './jsonEg/jsonEgStr'
import { remoteFuncsObj } from './remoteFuncs/remoteFuncsObj'
import formApi from './api/formApi'
import generateCode from './generateCode.js'
import moduleUtils from '../util/moduleUtils'
import alertUtils from '../util/alertUtils'
import formUtils from '../util/formUtils'
import { resolveJson, generateUUID } from '../util/index.js'
import { encrypt } from '@/util/crypto.js'
import { config } from '../config/config'
import WidgetSonPageForm from './WidgetSonPageForm'

export default {
  name: 'fm-making-form',
  components: {
    WidgetSonPageForm,
    Draggable,
    WidgetConfig,
    FormConfig,
    WidgetForm,
    CusDialog,
    MobileDialog,
    GenerateForm,
    SwEventConfig,
  },
  props: {
    tplChoice: {
      type: Boolean,
      default: true,
    },
    preview: {
      type: Boolean,
      default: false,
    },
    fullScreen: {
      type: Boolean,
      default: true,
    },
    generateCode: {
      type: Boolean,
      default: false,
    },
    generateJson: {
      type: Boolean,
      default: false,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    fileBaseApi: {
      type: String,
      default: '',
    },
    baseApi: {
      type: String,
      default: '',
    },
    clear: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    version: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
    remoteFormData: {
      type: Object,
      default: () => {},
    },
    platform: {
      type: String,
    },
  },
  data() {
    return {
      basicComponents,
      layoutComponents,
      advanceComponents,
      businessComponents,
      searchComponents,
      resetJson: false,
      formTplSelected: '',
      tplFormList: [], // 模板表单选择数组
      widgetForm: {
        // 所有组件json
        list: [],
        sonPages: {},
        config: {
          width: document.body.clientWidth,
          labelWidth: 100,
          labelPosition: 'right',
          size: 'small',
          disabled: false,
          justShow: false,
          customClass: 'sw-form-blue',
          // 修正错误代码逻辑
          fixHiddenDom: false,
        },
      },
      pageTab: 'main',
      configTab: 'widget', // tab 页选项
      widgetFormSelected: null, // 存放当前选中组件的数据，用于配置
      tplVisible: false,
      previewVisible: false,
      previewMobileVisible: false,
      jsonVisible: false,
      codeVisible: false,
      uploadVisible: false,
      remoteFuncs: remoteFuncsObj,
      widgetModels: {}, // 结果集  -  目前无用
      tableList: {}, // 对应id version 的表结构信息  表 - 字段 - 树形结构
      formInfo: {
        // 表单结果信息
        id: '',
        version: '',
        models: {}, // 对应的组件字段键值对
        value: {},
      },
      blank: '',
      htmlTemplate: '',
      jsonTemplate: '',
      uploadEditor: null,
      jsonEg: jsonEgStr,
      formTplSelectedJson: '',
      ftsjResolve: '',
      canNotSave: false, // 保存按钮能否点击
      currentUser: {},
      isToClose: false, //保存后是否关闭表单页面
      buttonConfig: {
        save: true,
        fullScreen: true,
        selectModel: false,
      },
      // 数据填报-关联模型字段
      modelJson: [],
    }
  },
  created() {
    if (this.platform === 'datafilling') {
      this.buttonConfig.save = false
      this.buttonConfig.fullScreen = false
      this.buttonConfig.selectModel = true
    }
    this.getBaseConfig()
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
  },
  computed: {
    curPage: {
      get() {
        return (
          this.widgetForm.sonPages[this.pageTab] &&
          this.widgetForm.sonPages[this.pageTab].list
        )
      },
      set(val) {
        if (this.widgetForm.sonPages[this.pageTab]) {
          this.widgetForm.sonPages[this.pageTab].list = val
        }
      },
    },
    mobileUrl() {
      return process.env.VUE_APP_MOBILE_PREVIEW + '?token=' + config.token
    },
  },
  methods: {
    getBaseConfig() {
      if (
        this.fileBaseApi &&
        this.fileBaseApi.toLowerCase().indexOf('http') > -1
      ) {
        config.fileBaseAPI = this.fileBaseApi
      }
      if (this.baseApi && this.baseApi.toLowerCase().indexOf('http') > -1) {
        config.baseAPI = this.baseApi
      }
      if (this.token) {
        config.token = this.token
      }
      localStorage.setItem('Admin-Token', config.token)
      this.formInfo.id = config.id
      this.formInfo.version = config.version
      if (this.id && this.version) {
        this.formInfo.id = this.id
        this.formInfo.version = this.version
      }
      if (this.formInfo.id && this.formInfo.version) {
        this.initDesignForm()
      }
    },
    initDesignForm() {
      if (
        process.env.NODE_ENV === 'development' &&
        config.pageType === 'design'
      ) {
        this.getRemoteJson()
        return
      }
      const remoteJson = Object.assign({}, this.remoteFormData)
      this.setJSON(remoteJson)
    },
    handleConfigSelect(value) {
      this.configTab = value
    },
    handleMoveEnd(evt) {},
    handleMoveStart({ oldIndex }) {},
    handleMove() {
      return true
    },

    handleFullScreen() {
      // 开启全屏显示
      if (!screenfull.isEnabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning',
        })
        return false
      }
      screenfull.toggle()
    },
    handlePreview() {
      this.previewVisible = true
      if (
        this.widgetFormSelected.type === 'date' &&
        this.widgetFormSelected.options.type === 'datetime'
      ) {
        // 修复date预览后切换datetime类型预览报错
        this.$nextTick(() => {
          const form = this.$refs.generateForm
          form.models[this.widgetFormSelected.model] = ''
          form.data.list.forEach(item => {
            if (item.model === this.widgetFormSelected.model) {
              item.options.value = ''
              item.options.defaultValue = ''
            }
          })
          console.log(this.$refs.generateForm, this.widgetFormSelected, 999)
          if (this.widgetFormSelected && this.widgetFormSelected.key) {
            this.$refs.generateForm.resetDateField(this.widgetFormSelected.key)
          }
        })
      }
    },
    handleMobilePreview() {
      this.previewMobileVisible = true
    },

    handlePcTest() {
      this.$refs.generateForm
        .getAllInfoDataNoRemote()
        .then(data => {
          console.log(data)
          this.$alert(data, '').catch(e => {})
          this.$refs.widgetPreview.end()
        })
        .catch(e => {
          this.$refs.widgetPreview.end()
        })
    },
    handleMobileTest() {
      this.$refs.vanGenerateForm
        .getData()
        .then(data => {
          this.$alert(data, '').catch(e => {})
        })
        .catch(e => {
          console.error(e)
          this.$alert(e.message)
        })
        .finally(() => {
          this.$refs.widgetMobilePreview.end()
        })
    },
    handleGenerateJson() {
      this.jsonVisible = true
      this.jsonTemplate = this.widgetForm
      this.$nextTick(() => {
        const editor = ace.edit('jsoneditor')
        editor.session.setMode('ace/mode/json')
        const btnCopy = new Clipboard('#copybtn')
      })
    },
    handleGenerateCode() {
      this.codeVisible = true
      this.htmlTemplate = generateCode(JSON.stringify(this.widgetForm))
      this.$nextTick(() => {
        const editor = ace.edit('codeeditor')
        editor.session.setMode('ace/mode/html')
      })
    },
    getTpl() {
      formApi.getAllPublishedForm().then(res => {
        this.tplFormList = res.data
      })
    },
    // 打开选择模板弹窗
    handleTpl() {
      // 默认等于当前数据
      this.formTplSelectedJson = this.widgetForm
      if (!this.tplFormList.length) {
        this.getTpl()
      }
      this.tplVisible = true
    },
    // 监听模板选择
    formTplSelectedChange(val) {
      const list = this.tplFormList
      const len = list.length
      let id = ''
      let version = ''
      for (let i = 0; i < len; i++) {
        if (list[i].id === val) {
          id = list[i].id
          version = list[i].version
          break
        }
      }
      this.ftsjResolve = '加载中。。。'
      formApi.getFormJson(id, version).then(response => {
        const remoteJson = JSON.parse(JSON.stringify(response))
        moduleUtils.updateModuleJson(remoteJson)
        this.formTplSelectedJson = remoteJson
        this.ftsjResolve = JSON.stringify(remoteJson, null, 4)
      })
    },
    handleTplJson() {
      this.setJSON(this.formTplSelectedJson)
      this.tplVisible = false
    },
    handleUpload() {
      this.uploadVisible = true
      this.$nextTick(() => {
        this.uploadEditor = ace.edit('uploadeditor')
        this.uploadEditor.session.setMode('ace/mode/json')
      })
    },
    handleUploadJson() {
      try {
        const uploadEditorJson = JSON.parse(this.uploadEditor.getValue())
        moduleUtils.updateModuleJson(uploadEditorJson)
        this.setJSON(uploadEditorJson)
        this.uploadVisible = false
      } catch (e) {
        alertUtils.alertError(e.message, true)
        this.$refs.uploadJson.end()
      }
    },
    handleClear() {
      this.$confirm('确认清空组件？')
        .then(_ => {
          this.widgetForm.list = []
          this.pageTab = 'main'
          this.widgetForm.sonPages = {}
          this.widgetFormSelected = null
        })
        .catch(_ => {})
    },
    getJSON() {
      return this.widgetForm
    },
    getHtml() {
      return generateCode(JSON.stringify(this.widgetForm))
    },
    setJSON(json) {
      if (!json || JSON.stringify(json) === '{}') {
        return
      }
      if (Object.keys(json.config).length > 0) {
        this.widgetForm.config = json.config
      }

      if (json.list.length > 0) {
        this.widgetForm.list = json.list.map(item => {
          console.log(item, 'item')

          if (item.type === 'date') {
            item.options.startDate = item.options.startDate || ''
            item.options.endDate = item.options.endDate || ''
          }
          if (item.type === 'report') {
            item.rows.forEach(rowItem => {
              rowItem.columns.forEach(columnItem => {
                if (columnItem.list) {
                  columnItem.list.forEach(listItem => {
                    if (
                      listItem.type === 'sonform' &&
                      listItem.model.search('sonform_') != -1 &&
                      listItem.model.search('sonform_colorful_egg_') == -1
                    ) {
                      const model = listItem.model.replace(
                        'sonform_',
                        'sonform_colorful_egg_'
                      )
                      listItem.model = model
                    }
                  })
                }
              })
            })
          }
          if (item.type === 'sonform') {
            if (!item.options.hasOwnProperty('prefix')) {
              item.options.prefix = ''
            }
            if (!item.options.hasOwnProperty('suffix')) {
              item.options.suffix = ''
            }
            if (!item.options.hasOwnProperty('addBtnName')) {
              item.options.addBtnName = '新增'
            }
          }
          return item
        })
        this.widgetFormSelected = json.list[0]
      }
      if (json.sonPages) {
        this.widgetForm.sonPages = json.sonPages
      }
    },
    getRemoteJson() {
      formApi
        .getFormJson(this.formInfo.id, this.formInfo.version)
        .then(response => {
          const remoteJson = JSON.parse(JSON.stringify(response))
          this.setJSON(remoteJson)
        })
        .catch(e => {
          alertUtils.alertError('查询远程JSON数据失败', true)
        })
    },
    getRemoteTableInfo() {
      formApi
        .getTableFields(this.formInfo.id)
        .then(response => {
          this.tableList = response
        })
        .catch(e => {
          alertUtils.alertError('查询表数据失败', true)
        })
    },
    saveFormConfirmNoClose() {
      this.isToClose = false
      this.saveFormInfo()
    },
    saveFormConfirm() {
      this.isToClose = true
      this.$confirm('确定保存？', '提示', { confirmButtonText: '保存并关闭' })
        .then(_ => {
          this.saveFormInfo()
        })
        .catch(_ => {})
    },
    saveFormInfo() {
      try {
        this.canNotSave = true
        this.jsonTemplate = this.widgetForm
        this.htmlTemplate = generateCode(JSON.stringify(this.widgetForm))
        this.formInfo.value = this.widgetModels
        this.formInfo.models = {}
        moduleUtils.generateModel(this.formInfo, this.widgetForm.list)
        // 原始参数
        const paramsData = {
          id: this.formInfo.id,
          version: this.formInfo.version,
          formHtml: this.htmlTemplate,
          moduleJson: moduleUtils.generateModuleJson(this.jsonTemplate),
          instanceJson: moduleUtils.generateInstanceJson(this.formInfo.models),
          // moduleJson: JSON.stringify(
          //   moduleUtils.generateModuleJson(this.jsonTemplate)
          // ),
          // instanceJson: JSON.stringify(
          //   moduleUtils.generateInstanceJson(this.formInfo.models)
          // ),
        }

        const uuid = generateUUID()
        const timeStr = Date.now()
        // 密钥
        const key = 'formflow' + timeStr
        // AES加密后的数据
        const formDTOStr = encrypt(paramsData, key)
        const data = {
          formDTOStr: formDTOStr,
        }
        const headers = {
          uuid: uuid,
          timeStr: timeStr,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        }

        if (this.isToClose) {
          alertUtils.alertInfo('正在保存...', true, 0)
        }
        // if (process.env.NODE_ENV === 'development') {
        //   console.log(data.moduleJson)
        //   return
        // }
        formApi
          .saveFormInfo(data, headers)
          .then(response => {
            if (response.flag) {
              alertUtils.alertSuccess('保存成功', true)
              if (
                !(
                  process.env.NODE_ENV === 'development' ||
                  window.self !== window.top
                )
              ) {
                //点击 '保存并关闭' 才关闭表单页面
                if (this.isToClose) {
                  window.close()
                }
              }
            } else {
              alertUtils.alertError('保存失败', true)
            }
            this.canNotSave = false
          })
          .catch(e => {
            alertUtils.alertError('保存失败', true)
            this.canNotSave = false
          })
      } catch (e) {
        console.log(e)
        alertUtils.alertError('保存失败', true)
        this.canNotSave = false
      }
    },
    getFormParams() {
      this.jsonTemplate = this.widgetForm
      this.htmlTemplate = generateCode(JSON.stringify(this.widgetForm))
      this.formInfo.value = this.widgetModels
      this.formInfo.models = {}
      moduleUtils.generateModel(this.formInfo, this.widgetForm.list)
      // 原始参数
      const paramsData = {
        id: this.formInfo.id,
        version: this.formInfo.version,
        formHtml: this.htmlTemplate,
        moduleJson: moduleUtils.generateModuleJson(this.jsonTemplate),
        instanceJson: moduleUtils.generateInstanceJson(this.formInfo.models),
      }
      const uuid = generateUUID()
      const timeStr = Date.now()
      // 密钥
      const key = 'formflow' + timeStr
      // AES加密后的数据
      const formDTOStr = encrypt(paramsData, key)
      return { formJson: formDTOStr, timeStr, uuid }
    },
    getModelParams() {
      return this.modelJson
    },
    handleSuccess(value) {
      this.modelJson = value
    },
    handleChangeModel() {
      this.$emit('change-model', true)
    },
  },
  watch: {
    widgetForm: {
      handler(val) {
        this.widgetForm = val
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.widget-empty {
  background: url('../assets/form_empty.png') no-repeat;
  background-position: 50%;
}

.custom1 .el-col {
  border: 1px solid #ccc;
  overflow: hidden;
  padding: 5px;
  margin-right: -1px;
  margin-bottom: -1px;
}

.custom .el-col {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.canClick {
  color: #f4f4f5;
}

.sw-tab-page {
  float: left;
  height: 42px;

  .el-tabs__nav-prev i {
    font-weight: bolder;
    font-size: 18px;
  }

  .el-tabs__nav-next i {
    font-weight: bolder;
    font-size: 18px;
  }
}
</style>
